import { useMutation } from '@tanstack/react-query';

import { FinancialPerformanceApi } from '../financialPerformance.api';

export const useGetPerformanceEfficiency = () => {
  return useMutation({
    mutationFn: FinancialPerformanceApi.getCalculationsOfPerformanceEfficiency,
  });
};
